import React, { useState } from 'react';

function QuestionContent4({ onNext, onBack }) {

  const [internal, setInternal] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [telephone, setTelephone] = useState('');
  const [relationship, setRelationship] = useState('');
  const [error, setError] = useState('');


  const handleInputChange = (event, setter) => {
    setter(event.target.value);
  };


  const handleSubmit = async (event) => {
    event.preventDefault();


    if (!internal || !surname || !email || !telephone || !relationship) {
      setError('All fields must be filled out.');
      return;
    }

    setError('');

    const data = {
      internal,
      surname,
      email,
      phone: telephone,
      relationship,
    };


    onNext({ data });

  };

  return (
    <div className="r-content">
      <h4 className="content-title">Safe Use of the Application:</h4>
      <p className="content-text">
        Ensure your identity remains protected by avoiding sharing personal information in forms or attachments. Use a secure internet connection with a lock symbol in your browser. Access the application or your mailbox only through a private device. Trusty AG, the developer, ensures no IP addresses are recorded and only uses temporary cookies for security. All communication is encrypted.
      </p>
      <br />
      <h4 className="content-title">Safe Use of the Application:</h4>
      <div className="content-text">
        The Olympic Committee of Slovenia manages all personal data transmitted through the application.
      </div>
      <form method="POST" className="questioncontent4-content" onSubmit={handleSubmit}>
        <div className="fill-opt1">
          <p>Internal</p>
          <input type="text" value={internal} onChange={(e) => handleInputChange(e, setInternal)} />
        </div>
        <div className="fill-opt1">
          <p>Surname</p>
          <input type="text" value={surname} onChange={(e) => handleInputChange(e, setSurname)} />
        </div>
        <div className="fill-opt1">
          <p>Electronic Mail</p>
          <input type="text" value={email} onChange={(e) => handleInputChange(e, setEmail)} />
        </div>
        <div className="fill-opt1">
          <p>Telephone Number</p>
          <input type="text" value={telephone} onChange={(e) => handleInputChange(e, setTelephone)} />
        </div>
        <div className="fill-opt1 lastinput">
          <p>Relationship to application subscriber</p>
          <input type="text" value={relationship} onChange={(e) => handleInputChange(e, setRelationship)} />
        </div>

        {/* Error message display */}
        {error && <div className="error" style={{ color: 'red', marginTop: '10px' }}>{error}</div>}

        <div className="back-next">
          <button type="button" className="Backbtn" onClick={onBack}>Back</button>
          <button type="submit" className="Nextbtn">Next</button> {/* Submit form */}
        </div>
      </form>
    </div>
  );
}

export default QuestionContent4;
